import moment from 'moment';
export const hasUppercase = (value) => (/[A-Z]/.test(value));
export const noUppercase = (value) => !(/[A-Z]/.test(value));
export const hasLowercase = (value) => (/[a-z]/.test(value));
const ALLOWED_SPECIAL_CHARS = /[!$%^&*()_+|~=`{}[:;<>?,.@#"'\\/\]\s]/;
export const hasSpecialCharacter = (value) => ALLOWED_SPECIAL_CHARS.test(value);
export const validCurrency = (value) => (/\d+(\.\d*)?|\.\d+/.test(value.toString()));
export const tenDigitPhone = (value) => {
    const digits = value.replace(/[^0-9]+/g, '');
    // Only return false if there is a value to test AND its invalid.
    return value.trim().length ? (/[0-9]/.test(digits)) && digits.length === 10 : true;
};
export const exactLength = (param) => (value) => {
    return value.length === param;
};
export const hasNumber = (value) => (/[0-9]/.test(value));
export const dateFormat = (format) => (value) => {
    return moment(value, format, true).isValid();
};
export const validUsername = (value) => {
    return !/[!$%^&*()_+|~=`{}[:;<>?,.@#"'\\/\]\s]/.test(value);
};
export const remote = (callBack) => (value) => {
    return callBack(value);
};
export const validRoutingNumber = (value) => {
    // To validate a routing number, you take each digit, and multiply it by 3, 7, or 1, starting with the
    // 1st and then summing the values. Every new digit, you move to the next of 3, 7, or 1 and start over
    // until you have multiplied and summed all 9 digits. The sum should then be divisible by 10.
    const modulus = [3, 7, 1];
    const numbersRe = /^\d+$/;
    const test = value.toString();
    // Make sure we only have numbers and exactly 9 digits.
    if (!numbersRe.test(test) || test.length !== 9) {
        return false;
    }
    // Generate an array of each digit.
    const digits = test.split('').map(char => Number(char));
    const result = digits.map((digit, idx) => {
        return (digit * modulus[idx % 3]);
    }).reduce((cumulative, value) => {
        return cumulative + value;
    });
    // If we are divisible by 10, its a valid routing number.
    return (result % 10 === 0);
};
export const validFtpHost = (value) => {
    // NOTE: RE is from here: https://github.com/jquery-validation/jquery-validation/blob/master/src/additional/url2.js#L3
    // Modified only to remove the protocol from the front.
    const RE = /^(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)*(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
    // All valid URLs require at least 1 period, so preface regex test with an indexOf to negate plain ole network hostnames from being valid.
    return value.indexOf('.') > 0 ? RE.test(value) : false;
};
